module.exports = __webpack_public_path__ + "images/signup-wechat-c9c8b9f2132b7d4c2fa81b75881bdad6.png";